// extracted by mini-css-extract-plugin
module.exports = {"modal":"Contact_modal__95QAj","contactForm":"Contact_contactForm__1ZJbQ","textInput":"Contact_textInput__3RpFS","checkbox":"Contact_checkbox__1HVLm","btn":"Contact_btn__3CCDK"};